import React from 'react';
import Tippy from '@tippyjs/react';

import '../styles/revenueBaseTooltip.css';

export const REVENUE_BASE_OPTIONS = [
  { value: 'default', label: 'Default' },
  { value: 'gross', label: 'Gross' },
  { value: 'net_gross', label: 'Net Gross' },
  { value: 'adjusted_gross', label: 'Adjusted Gross' }
];

const BUTTON_ACTIVATION_KEYS = ['Enter', ' '];

const clickOnActivationKey = (event) => {
  if (!BUTTON_ACTIVATION_KEYS.includes(event.key)) return;
  event.preventDefault();
  event.currentTarget.click();
};

export const RevenueBaseTooltip = () => (
  <Tippy
    content={
      <div>
        <div><strong>Default:</strong> uses the standard split-point calculation. The show first recoups expenses and any promoter profit, then applies the artist percentage to what remains. On a plus deal the guarantee is recouped first too; on a versus deal the artist gets the greater of the guarantee or that percentage. A breakeven threshold or deal brackets, when in effect, change what the percentage applies to.</div>
        <div className="mt-1"><strong>Gross (GBOR):</strong> total ticket revenue before taxes, fees, or expenses.</div>
        <div className="mt-1"><strong>Net Gross (NBOR):</strong> ticket revenue after taxes and facility fees.</div>
        <div className="mt-1"><strong>Adjusted Gross:</strong> NBOR after selected show expenses are also deducted.</div>
      </div>
    }
    placement="top"
    trigger="mouseenter focus click"
    interactive={true}
    appendTo={() => document.body}
    aria={{ content: 'describedby' }}
  >
    <i
      className="fas fa-info-circle ml-1 revenue-base-tooltip__icon"
      role="button"
      tabIndex={0}
      aria-label="Revenue base explanation"
      onClick={(event) => event.preventDefault()}
      onKeyDown={clickOnActivationKey}
    ></i>
  </Tippy>
);
